<div class="backlog-reports">

  <div class="filters">
    <div class="filter" [ngClass]="{'active': selectedFilter === 'week'}"
         (click)="onChangeFilter('week')">
      <span>week v last</span>
    </div>
    <div class="filter" [ngClass]="{'active': selectedFilter === 'month'}"
         (click)="onChangeFilter('month')">
      <span>month v last</span>
    </div>
    <div class="filter" [ngClass]="{'active': selectedFilter === 'year'}"
         (click)="onChangeFilter('year')">
      <span>year v last</span>
    </div>
    <div class="filter" [ngClass]="{'active': selectedFilter === 'custom'}">
      <span>
        <span class="hidden-overlay" (click)="selectedFilter = 'custom'"
              *ngIf="selectedFilter !== 'custom'"></span>
        <form (submit)="updateReports('custom')">
          from:
          <p-calendar class="primeng-date" [(ngModel)]="fromDate"
                      [maxDate]="currentDate" readonlyInput="true"
                      placeholder="05/05/2018" dateFormat="dd/mm/yy" name="fromDate"
                      [disabled]="selectedFilter !== 'custom'"></p-calendar>
          to:
          <p-calendar class="primeng-date" [(ngModel)]="toDate"
                      [minDate]="fromDate" [maxDate]="currentDate" readonlyInput="true"
                      placeholder="05/07/2018" dateFormat="dd/mm/yy" name="toDate"
                      [disabled]="selectedFilter !== 'custom'"></p-calendar>
          <input aria-label=""  type="submit" class="app-submit" value="Search"
                 [disabled]="fromDate === null || toDate === null
                 || selectedFilter !== 'custom'">
        </form>
      </span>
    </div>
  </div>

  <div class="reports-content">
    <div class="report-titles">
      <h2>backlog performance (days to respond)</h2>
      <h3>{{dateRangeText}}</h3>
    </div>

    <div class="backlog-table">


      <div class="table-helper box-shadow" [ngStyle]="{'opacity': loadingState ? '0' : '1'}">
        <table class="table-list" id="reports-backlog-table">
          <thead>
            <tr class="export-only-row">
              <td colspan="10" nowrap="nowrap">{{dateRangeText}}</td>
            </tr>
            <!-- <tr>
              <td colspan="3"><span class="strong">informal-challenge stage</span></td>
              <td colspan="3"><span class="strong">representations stage</span></td>
              <td colspan="3"><span class="strong">other stages</span></td>
              <td><span class="strong">value</span></td>
            </tr> -->
            <tr>
              <td>
                <span class="popover-item" [ngbPopover]="wkgDays1"
                      triggers="hover" placement="top">wkg days <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                      class="icon icon-active" alt="working days" /></span>
                <ng-template #wkgDays1>
                  <div [innerHTML]="reportsCopy.wkgDays | safe: 'html'"></div>
                </ng-template>
              </td>
              <td>
                <span class="popover-item" [ngbPopover]="calDays1"
                      triggers="hover" placement="top">cal days <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                      class="icon icon-active"  alt="calendar days"/></span>
                <ng-template #calDays1>
                  <div [innerHTML]="reportsCopy.calDays | safe: 'html'"></div>
                </ng-template>
              </td>
              <td class="space-right">
                <span class="popover-item" [ngbPopover]="change1"
                      triggers="hover" placement="top">change <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                      class="icon icon-active"  alt="change"/></span>
                <ng-template #change1>
                  <div [innerHTML]="reportsCopy.calDays | safe: 'html'"></div>
                </ng-template>
              </td>
              <td>
                <span class="popover-item" [ngbPopover]="wkgDays2"
                      triggers="hover" placement="top">wkg days <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                      class="icon icon-active"  alt="working days"/></span>
                <ng-template #wkgDays2>
                  <div [innerHTML]="reportsCopy.wkgDays | safe: 'html'"></div>
                </ng-template>
              </td>
              <td>
                <span class="popover-item" [ngbPopover]="calDays2"
                      triggers="hover" placement="top">cal days <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                      class="icon icon-active" alt="calendar days"/></span>
                <ng-template #calDays2>
                  <div [innerHTML]="reportsCopy.calDays | safe: 'html'"></div>
                </ng-template>
              </td>
              <td class="space-right">
                <span class="popover-item" [ngbPopover]="change2"
                      triggers="hover" placement="top">change <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                      class="icon icon-active"  alt="change"/></span>
                <ng-template #change2>
                  <div [innerHTML]="reportsCopy.calDays | safe: 'html'"></div>
                </ng-template>
              </td>
              <td>
                <span class="popover-item" [ngbPopover]="wkgDays3"
                      triggers="hover" placement="top">wkg days <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                      class="icon icon-active"  alt="working days"/></span>
                <ng-template #wkgDays3>
                  <div [innerHTML]="reportsCopy.wkgDays | safe: 'html'"></div>
                </ng-template>
              </td>
              <td>
                <span class="popover-item" [ngbPopover]="calDays3"
                      triggers="hover" placement="top">cal days <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                      class="icon icon-active"  alt="calendar days"/></span>
                <ng-template #calDays3>
                  <div [innerHTML]="reportsCopy.calDays | safe: 'html'"></div>
                </ng-template>
              </td>
              <td>
                <span class="popover-item" [ngbPopover]="change3"
                      triggers="hover" placement="top">change <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                      class="icon icon-active"  alt="change"/></span>
                <ng-template #change3>
                  <div [innerHTML]="reportsCopy.change | safe: 'html'"></div>
                </ng-template>
              </td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span>
                  {{backlogReport.informalChallengeAverageWorkingDays}}
                </span>
              </td>
              <td>
                <span>
                  {{backlogReport.informalChallengeAverageDays}}
                </span>
              </td>
              <td class="space-right">
                <span>
                  {{backlogReport.informalChallengeChange}}
                </span>
              </td>
              <td>
                <span>
                  {{backlogReport.representationAverageWorkingDays}}
                </span>
              </td>
              <td>
                <span>
                  {{backlogReport.representationAverageDays}}
                </span>
              </td>
              <td class="space-right">
                <span>
                  {{backlogReport.representationChange}}
                </span>
              </td>
              <td>
                <span>
                  {{backlogReport.otherAverageWorkingDays}}
                </span>
              </td>
              <td>
                <span>
                  {{backlogReport.otherAverageDays}}
                </span>
              </td>
              <td class="space-right">
                <span>
                  {{backlogReport.otherChange}}
                </span>
              </td>
              <td>
                <span>
                  {{backlogReport.backlogValue}}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div class="download-btns">
      <button class="app-submit secondary" (click)="downloadDocument('pdf')">
        PDF&nbsp;&nbsp;
        <img [src]="constants.assetsPath + '/img/icons/download-white.svg'" width="14">
      </button>
      <button class="app-submit secondary" (click)="downloadDocument('excel')">
        EXCEL&nbsp;&nbsp;
        <img [src]="constants.assetsPath + '/img/icons/download-white.svg'" width="14">
      </button>
    </div>

  </div>


</div>
